import { ReactComponent as EducationEqualityIcon } from "../assets/icons/categories/education_equality.svg";
import { ReactComponent as EntertainmentIcon } from "../assets/icons/categories/entertainment.svg";
import { ReactComponent as EnvironmentClimateIcon } from "../assets/icons/categories/environment_climate.svg";
import { ReactComponent as FashionIcon } from "../assets/icons/categories/fashion.svg";
import { ReactComponent as GastronomyIcon } from "../assets/icons/categories/gastronomy.svg";
import { ReactComponent as MusicIcon } from "../assets/icons/categories/music.svg";
import { ReactComponent as OthersIcon } from "../assets/icons/categories/others.svg";
import { ReactComponent as PeaceJusticeCooperationIcon } from "../assets/icons/categories/peace_justice_cooperation.svg";
import { ReactComponent as SportIcon } from "../assets/icons/categories/sport.svg";
import { ReactComponent as TourismIcon } from "../assets/icons/categories/tourism.svg";
import { ReactComponent as WellnessQualityOfLifeIcon } from "../assets/icons/categories/wellness_quality_of_life.svg";
import { ReactComponent as WorkEconomyInnovationIcon } from "../assets/icons/categories/work_economy_innovation.svg";

const categoryIcon = {
    'education-equality': EducationEqualityIcon,
    'entertainment': EntertainmentIcon,
    'environment-climate': EnvironmentClimateIcon,
    'fashion': FashionIcon,
    'gastronomy': GastronomyIcon,
    'music': MusicIcon,
    'others': OthersIcon,
    'peace-justice-cooperation': PeaceJusticeCooperationIcon,
    'sport': SportIcon,
    'tourism': TourismIcon,
    'wellness-quality-of-life': WellnessQualityOfLifeIcon,
    'work-economy-innovation': WorkEconomyInnovationIcon,
}

export const getCategoryIcon = (category) => categoryIcon[category] || null;